import { createRoot } from "react-dom/client";
import "@mantine/spotlight/styles.css";
import { App } from "./App";

const container = document.getElementById("app");
const root = createRoot(container as HTMLElement);
root.render(<App />);
